import { conf } from '../../configService';
import { dateService } from '../../dateService';
import { personType } from './personType';
import { organizationType } from './organizationType';
import { imageObjectType } from './imageObjectType';
import {
  getContentModificationDate,
  getContentPublishDate
} from '../../../utils/contentUtils';
import { removeEmptyProperties } from '../../../utils/objectUtils';

// @see https://schema.org/Article
export const articleType = content => {
  let schemaAuthor;
  if (['author', 'photographer'].includes(content.bundle)) {
    schemaAuthor = content.title;
  } else {
    const authors = content.authors
      ? content.authors.map(author =>
          author.entity ? personType(author.entity.name) : undefined
        )
      : [];
    schemaAuthor = authors.length > 1 ? [authors] : authors[0];
  }

  let imageEntity = content.image?.entity || content.promoImage?.[0]?.entity;
  if (!imageEntity) {
    // There are some cases when an article contains only a photo gallery node,
    // but the article doesn't contain any image. That usually happens with
    // legacy contents when images were not mandatory.
    // In such cases, look for the first image inside the photo gallery.
    if (content.mainContent && Array.isArray(content.mainContent)) {
      const photoGallery = content.mainContent.find(
        paragraph =>
          paragraph.entity &&
          paragraph.entity.type === 'ParagraphGalleryInlineElement'
      );
      imageEntity =
        photoGallery?.entity?.photoGallery?.entity?.images?.[0]?.entity;
    }
  }

  return removeEmptyProperties({
    '@type': 'Article',
    headline: content.title,
    name: content.subHeadline,
    datePublished: dateService.format(
      getContentPublishDate(content) * 1000,
      'iso-no-milliseconds'
    ),
    dateModified: dateService.format(
      getContentModificationDate(content) * 1000,
      'iso-no-milliseconds'
    ),
    publisher: organizationType(),
    author: personType(schemaAuthor || conf.siteName),
    mainEntityOfPage: `https://${conf.canonicalDomain}${content.url?.path}`,
    image: imageObjectType(imageEntity)
  });
};
